import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * @Deprecated: Use `@infodata-group/inf-commons-desktop` instead
 */
@Component({
  selector: 'infl-info',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './info.component.html',
  styleUrl: './info.component.scss',
})
export class InfoComponent {
  public text = input.required<string>();
  public icon = input<string | null>(null);
}
